export default __webpack_public_path__ + "static/media/folajuNcake_w640.704cd2d5.jpeg";